import { render } from "./MainPage.vue?vue&type=template&id=e6e8ee60"
import script from "./MainPage.vue?vue&type=script&lang=js"
export * from "./MainPage.vue?vue&type=script&lang=js"

import "./MainPage.vue?vue&type=style&index=0&id=e6e8ee60&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__